import { ArchiveSyncOutlineIcon } from './ArchiveSyncOutlineIcon';

/**
 * author: Colton Wiscombe
 * id BB297982-E355-4AEE-9D17-CD57BDB0625A
 * name archive-sync-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-sync-outline.svg
 * tags
 */
export const BoxSyncOutlineIcon = ArchiveSyncOutlineIcon;
export default BoxSyncOutlineIcon